import { Modal } from "antd";
import "antd/dist/antd.min.css";
import { FormEventHandler } from "react";
import { Botao } from "../Botao";
import { Link } from "react-router-dom";
import { IconPrinter } from "../../Icons/IconPrinter";
import { URLS } from "../../../infra/URLS";

import { Spin } from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
const loadingIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;


interface CreateModalProps {
  isLoading?: boolean;
  isModalOpen: boolean;
  title: string;
  onCancel: () => void;
  children: React.ReactNode;
  footerContent?: React.ReactNode;
  onSubmit?: FormEventHandler | undefined;
  hasId?: boolean;
  onDelete?: FormEventHandler | undefined;
  deleteOpenModal?: () => void;
  closable?: boolean;
  disabled?: boolean;
  setDisabled?: () => void;
  buttonDelete?: boolean;
  hideButton?: boolean;
  movToPrint?: boolean
}


export function CreateModal({
  isLoading,
  isModalOpen,
  hasId,
  closable,
  title,
  onCancel,
  children,
  onSubmit,
  deleteOpenModal,
  disabled,
  setDisabled,
  buttonDelete,
  movToPrint,
  hideButton
}: CreateModalProps) {
  return (
    <Modal
      closable={closable}
      className="h-[80vh] flex justify-center items-center"
      open={isModalOpen}
      title={title}
      onCancel={() => onCancel()}
      footer={hideButton ? false : (hasId ?
        <form className="flex flex-row justify-between" onSubmit={onSubmit}>
          {
            buttonDelete ? <div /> :
              <Botao
                type="button"
                onClick={deleteOpenModal}
                texto="Excluir"
                className="bg-error text-white"
              />
          }
          <div className="flex flex-row items-center gap-4">
            {
              movToPrint && <Link to={URLS.MOVIMENTOS_IMPRESSAO} target="_blank">
                <Botao url='' type='button' icon={<IconPrinter width={24} color={"#f3f3f3"} />} className="bg-primary py-0" />
              </Link>
            }
            {
              disabled &&
              <Botao
                type="button"
                onClick={setDisabled}
                texto="Editar"
                className="bg-info text-white"
              />
            }
            {!disabled && <Botao
              disabled={isLoading && true}
              type="submit"
              texto={isLoading ? <span><Spin indicator={loadingIcon} /> Enviando</span> : "Salvar"}
              className="bg-primary text-white"
            />
            }
          </div>
        </form>
        :
        <form className="flex flex-row justify-between" onSubmit={onSubmit}>
              <Botao type="reset" texto="Cancelar" onClick={onCancel} />
              <Botao
                disabled={isLoading && true}
                type="submit"
                texto={isLoading ? <span><Spin indicator={loadingIcon} /> Enviando</span> : "Salvar"}
                className={`${isLoading ? 'bg-primary-hover' : 'bg-primary'} text-white`}
              />
        </form>)
      }
    >
      {children}
    </Modal>
  );
}
